import React from 'react'
import {
  Grid,
} from '@material-ui/core'
import * as Styled from './styled'
import PropTypes from 'prop-types'

const FaqQuestionItem = ({ questions, handleClickQuestion, withBorder, fullWidth }) => {
  return (
    <Grid container spacing={2}>
      {questions.map(question => (
        <Grid
          item
          xs={12}
          sm={fullWidth ? 12 : 6}
          key={question.text}
          onClick={() => handleClickQuestion(question)}
        >
          <Styled.Question withborder={Number(withBorder)}>{question.text}</Styled.Question>
        </Grid>
      ))}
    </Grid>
  )
}

FaqQuestionItem.propTypes = {
  withBorder: PropTypes.bool,
  questions: PropTypes.array.isRequired,
  handleClickQuestion: PropTypes.func.isRequired,
};

export default React.memo(FaqQuestionItem)
